import {
  DEVICEMANAGELIST} from '../actions/deviceManage';
import {reducerPackage} from "../../utils";

export const deviceManageList = reducerPackage(DEVICEMANAGELIST);

